import { type TranslationTree } from '@/i18n/types';

export const messages = {
  organization: 'Organização',
  legalName: 'Razão social',
  contact: 'Contato',
  region: 'Região',
  web: 'Na internet',
  notInformed: 'Não informado',
  edit: 'Editar',
  acceptTermsLead: 'Li e aceito os termos de parceiro e a ',
  privacyPolicy: 'Política de Privacidade',
  reviewNote: 'A Bodyprint confere os dados antes de liberar a conta.',
  resubmitNote: 'Ao salvar, a conta segue para a análise da Bodyprint.',
} satisfies TranslationTree;
